<template>
  <div class="equipRun">
    <div class="detail_list">
      <div class="detail_h flex align_center">
        <div>{{ $t("Parameters") }}</div>
        <div>{{ $t("Run") }}</div>
        <div>{{ $t("Reference") }}</div>
      </div>
      <div class="detail_form">
        <div class="form_data flex" v-for="(data, i) in equipList" :key="i">
          <div class="unit" style="text-align:left;padding-left:5px">{{ data.params }}</div>
          <div class="run">{{ data.run }}</div>
          <div class="stopTime">{{ data.example }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    equipList() {
      return [
        {
          params: this.$t("Roots pump motor real-time rotational speed"),
          run: 1000,
          example: 2375
        },
        {
          params: this.$t("Roots pump motor real-time current"),
          run: 5.82,
          example: 5.82
        },
        {
          params: this.$t("Roots pump inlet pressure"),
          run: 2,
          example: 2
        },
        {
          params: this.$t("Screw pump motor real-time rotational speed"),
          run: 2950,
          example: 2950
        },
        {
          params: this.$t("Screw pump motor real-time current"),
          run: 22,
          example: 22
        },
        {
          params: this.$t("Screw pump inlet pressure"),
          run: 9,
          example: 9
        }
      ];
    }
  },
  mounted() {},
  methods: {},
  components: {}
};
</script>

<style scoped lang="scss">
@import url("../../../../../assets/scss/common.scss");
.equipRun {
  width: 100%;
  height: 100%;
  font-size: 16px;
  overflow: hidden;
}
.detail_list {
  height: 100%;
  display: flex;
  flex-flow: column;
}
.detail_h {
  background: #22282e;
  padding: 5px 0;
  > div {
    flex: 1;
    text-align: center;
    &:nth-of-type(1) {
      flex: 2;
    }
  }
}

.output_num {
  font-size: 16px;
  > div {
    margin-right: 10px;
    text-align: center;
    word-wrap: break-word;
    &:nth-last-of-type(1) {
      margin-right: 0;
    }
  }
}
.detail_form {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-flow: column;
  .form_data {
    flex: 1;
    display: flex;
    align-items: center;
    &:nth-of-type(2n) {
      background: #22282e;
    }
    &:nth-of-type(2n + 1) {
      background: transparent;
    }
    > div {
      flex: 1;
      text-align: center;
      &:nth-of-type(1) {
        flex: 2;
      }
    }
  }
  .run {
    color: #04ffff;
  }
}
</style>
